var React = require('react');

function Post (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#5f67b9","key":0}),React.createElement("rect",{"rx":"32","ry":"32","x":"112","y":"80","width":"288","height":"352","fill":"#fff","key":1}),React.createElement("path",{"d":"M240 128h-40v112h-16V128h-40v-16h96z","aria-label":"T","fill":"#3d448b","key":2}),React.createElement("path",{"opacity":".7","fill":"#5875d4","d":"M272 112h112v48H272zM272 192h112v48H272zM144 272h240v48H144zM144 352h192v48H144z","key":3})]);
}

Post.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Post;

Post.default = Post;
